import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { toast } from 'react-toastify';

export default function EnterCode() {
  const {
    code,
    setCode,
  } = useContext(AuthContext);

  const navigate = useNavigate();

  const verifyCode = async (e) => {
    if (e) e.preventDefault();
    try {
      // Phone is NOT sent from the client — the backend reads it from the DB
      // using the authenticated JWT. Only the 6-digit code is submitted.
      // ISO 27001 A.8.5 / SOC 2 CC6.1
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/trader/verify-code`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code }),
      });

      const data = await response.json();

      if (data.valid) {
        const nextStep = 'trader-dashboard' ;
        //const clientsRes = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/clients`);
        //const clientsData = await clientsRes.json();
        //setClients(clientsData);
        toast.success('Verification successful!');
        navigate(`/${nextStep}`);
      } else {
        toast.error('Invalid verification code');
      }
    } catch (err) {
      console.error('Verify error:', err);
      toast.error('Server error verifying code');
    }
  };

  return (
    <form className="login-form" onSubmit={verifyCode}>
      <h2>Enter Verification Code</h2>
      <input
        type="text"
        placeholder="6-digit Code"
        value={code}
        onChange={(e) => setCode(e.target.value)}
        required
        autoFocus
      />
      <button type="submit">Verify</button>
  </form>

  );
}
